import React from 'react'
import {useMutation} from '@apollo/client'
import {
  DELETE_EMPREENDIMENTO_IMOVEL_CORRETOR,
  DELETE_EMPREENDIMENTO_IMOVEL_CORRETOR_BY_ID,
  GET_EMPREENDIMENTO_CORRETORES,
} from '../../../../../../graphql'
import {
  DeleteEmpreendimentoCorretorResponse,
  DeleteEmpreendimentoImovelCorretoresByIdResponse,
} from '../../../../../../graphql/type/empreendiemnto_corretor'
import Swal from 'sweetalert2'
import {BiTrash} from 'react-icons/bi'

type Props = {
  id: number
  idCorretor: number
  idEmpreendimento: number
}

export const Buttons: React.FC<Props> = ({id, idCorretor, idEmpreendimento}) => {
  const [deleteEmpreendimentoCorretorTerreno, {loading}] =
    useMutation<DeleteEmpreendimentoImovelCorretoresByIdResponse>(
      DELETE_EMPREENDIMENTO_IMOVEL_CORRETOR_BY_ID,
      {
        refetchQueries: [GET_EMPREENDIMENTO_CORRETORES],
      }
    )

  async function HandleDelete() {
    Swal.fire({
      title: 'Deseja remover este corretor para todos os lotes?',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Remover',
      showCloseButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        deleteEmpreendimentoCorretorTerreno({
          variables: {
            id: id,
          },
          refetchQueries: [GET_EMPREENDIMENTO_CORRETORES],
        }).then((data) => {
          if (data) {
            Swal.fire('Item Removido', 'Removido com sucesso.', 'success')
          } else {
            Swal.fire('Erro', 'Erro ao remover o corretor.', 'warning')
          }
        })
      }
    })
  }
  return (
    <>
      <div className='d-flex justify-content-end flex-shrink-0'>
        <button
          onClick={HandleDelete}
          disabled={loading}
          className='btn btn-icon btn-danger btn-sm'
        >
          <BiTrash></BiTrash>
        </button>
      </div>
    </>
  )
}
